import {
  UseMutateAsyncFunction,
  UseMutateFunction,
  useMutation,
} from "@tanstack/react-query";
import {
  CompanyListItemAdminDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesAdminApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_EXPORT_ADMIN_COMPANIES = "EXPORT_ADMIN_COMPANIES";

const allowedRoles = [UserRole.Admin];

const exportAdminCompanies = async (
  search?: string,
): Promise<CompanyListItemAdminDto[]> => {
  const response =
    await companiesAdminApi.companiesAdminControllerExportAdminCompanies(search);

  return response.data;
};

export const useExportAdminCompanies = (
  user: UserProfileDto | null,
): {
  exportAdminCompanies: UseMutateFunction<
    CompanyListItemAdminDto[],
    unknown,
    string | undefined,
    unknown
  >;
  exportAdminCompaniesAsync: UseMutateAsyncFunction<
    CompanyListItemAdminDto[],
    unknown,
    string | undefined,
    unknown
  >;
  exportAdminCompaniesEnabled: boolean;
  isSuccessExportAdminCompanies: boolean;
  isPendingExportAdminCompanies: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { mutate, mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_COMPANIES, ACTION_EXPORT_ADMIN_COMPANIES],
    mutationFn: enabled ? exportAdminCompanies : undefined,
  });

  return {
    exportAdminCompanies: mutate,
    exportAdminCompaniesAsync: mutateAsync,
    exportAdminCompaniesEnabled: enabled,
    isSuccessExportAdminCompanies: isSuccess,
    isPendingExportAdminCompanies: isPending,
  };
};
